import { render, staticRenderFns } from "./Lastlink.vue?vue&type=template&id=05255bbc&"
import script from "./Lastlink.vue?vue&type=script&lang=js&"
export * from "./Lastlink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports